module.exports = __webpack_public_path__ + "static/media/bg6.f6faa4cc.jpg";